import { render } from "./Locale.vue?vue&type=template&id=69b8f8ec&scoped=true&ts=true"
import script from "./Locale.vue?vue&type=script&lang=ts"
export * from "./Locale.vue?vue&type=script&lang=ts"

import "./Locale.vue?vue&type=style&index=0&id=69b8f8ec&lang=scss&scoped=true"

import exportComponent from "/Users/suhwanlim/Projects/pr/MoTobi-Web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69b8f8ec"]])

export default __exports__